import { jsx as _jsx } from "react/jsx-runtime";
import { WalletEvents } from '@trinity/wallet';
import { createContext, useCallback, useEffect, useState } from 'react';
const InitialState = {
    isConnected: false,
    isInstalled: false,
    isInitialized: false,
    address: undefined,
};
export const WalletContext = createContext(null);
export const WalletProvider = ({ children, wallet, autoConnect = false }) => {
    const [walletState, setWalletState] = useState(InitialState);
    const { isConnected, address, isInstalled, isInitialized: isReady } = walletState;
    const refreshState = useCallback(async () => {
        const isInstalled = wallet.isAvailable();
        const walletAddress = await wallet.getAddress();
        const isConnected = isInstalled && Boolean(walletAddress);
        setWalletState({
            isConnected,
            isInstalled,
            address: walletAddress,
            isInitialized: true,
        });
    }, [wallet]);
    const connect = useCallback(async () => {
        await wallet.connect();
        await refreshState();
    }, [wallet, refreshState]);
    const disconnect = useCallback(async () => {
        await wallet.disconnect();
        await refreshState();
    }, [wallet, refreshState]);
    useEffect(() => {
        refreshState();
    }, [refreshState]);
    useEffect(() => {
        Object.values(WalletEvents).forEach((event) => {
            wallet.on(event, refreshState);
        });
        return () => {
            Object.values(WalletEvents).forEach((event) => {
                wallet.off(event, refreshState);
            });
        };
    }, [wallet, refreshState]);
    useEffect(() => {
        if (wallet.isAvailable() && autoConnect) {
            connect();
        }
    }, [autoConnect, connect, wallet]);
    return (_jsx(WalletContext.Provider, { value: { isConnected, address, isInstalled, isReady, connect, disconnect }, children: children }));
};
//# sourceMappingURL=wallet.js.map